import styled from "styled-components";

export const ContentHeader = styled.div`
  margin-top: -1rem;
  margin-bottom: 1rem;
`;

/**
 * @deprecated
 */
export default ContentHeader;
